// extracted by mini-css-extract-plugin
module.exports = {"textarea":"Textarea_textarea__1VaDK","error-message":"Textarea_error-message__2NuH8"};